import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  makeStyles,
  Theme,
  Typography,
  useMediaQuery,
} from '@material-ui/core';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player/youtube';
import { useParams } from 'react-router-dom';

import noImage from '../../../../shared/assets/no-image.png';
import { Button } from '../../../../shared/components/Button';
import ButtonLoadMore from '../../../../shared/components/Button/ButtonLoadMore/intex';
import { Flex } from '../../../../shared/components/Flex';
import { Header } from '../../../../shared/components/Header';
import { PageContainer } from '../../../../shared/components/PageContainer';
import { useBlog } from '../../../../shared/hooks/reactQuery/useBlog';

import 'moment/locale/pt-br';

moment.locale('pt-br');

interface BlogProps {
  id: number;
  title: string;
  description: string;
  image_url: string;
  created_at: string;
  url?: string;
}
const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    height: 'auto',
    border: 'none',
    background: 'transparent',
    borderRadius: theme.spacing(1),
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.15)',
    padding: 0,
  },

  container: {
    display: 'flex',
    width: '100%',
    border: 'none',
    overflow: 'hidden',
    maxHeight: theme.spacing(20),
    borderRadius: theme.spacing(1),
    background: theme.palette.background.paper,
    borderBottom: `3px solid ${theme.background.primary}`,
    [theme.breakpoints.up('sm')]: {
      maxHeight: theme.spacing(20),
    },
  },

  image: {
    width: '100%',
    maxWidth: '20vh',
    maxHeight: '150px',
    objectFit: 'cover',
    objectPosition: 'center',
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
    [theme.breakpoints.up('sm')]: {
      maxHeight: theme.spacing(20),
    },
    [theme.breakpoints.down(370)]: {
      maxWidth: '15vh',
    },
  },
  modalImage: {
    width: '100%',
    objectFit: 'cover',
    objectPosition: 'center',
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  title: {
    color: theme.text.primary,
  },
  t: {
    '& a': {
      color: '#001b85 !important',
      textDecoration: 'underline !important',
    },
  },
}));
export function Blog() {
  const classes = useStyles();

  const { id: blogIdFromRoute } = useParams<{ id: string }>();

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage } = useBlog();

  const isNotMobile = useMediaQuery('(min-width:600px)');

  const [currentBlogPost, setCurrentBlogPost] = useState<BlogProps | null>(
    null
  );
  const [currentVideo, setCurrentVideo] = useState<BlogProps | null>(null);
  const [videoModal, setVideoModal] = useState(false);
  const [blogModal, setBlogModal] = useState(false);

  const openModal = (item: BlogProps) => {
    setCurrentBlogPost(item);
    setBlogModal(true);
  };
  const closeModal = () => {
    setBlogModal(false);
    setCurrentBlogPost(null);
  };

  useEffect(() => {
    if (!blogIdFromRoute || !data) return;

    const numericId = Number(blogIdFromRoute);

    const allBlogs = data.pages.flatMap((page) => page.results);
    const found = allBlogs.find((blog) => blog.id === numericId);

    if (found) {
      openModal(found);
    }
  }, [blogIdFromRoute, data]);

  return (
    <>
      <PageContainer display="flex" flexDirection="column" position="relative">
        <Header goPush="/" title="Blog" />
        {data &&
          data.pages.map((group, index) => (
            <React.Fragment key={index}>
              {group.results.map((item) => {
                return (
                  <Box
                    key={item.id}
                    style={{
                      width: '100%',
                      background: '#fff',
                      borderRadius: 10,
                      boxShadow: '0 1px 2px rgba(0,0,0,0.15)',
                      marginBottom: 16,
                      padding: 30,
                    }}
                  >
                    <Typography
                      variant="body2"
                      style={{
                        color: '#777',
                        fontSize: 12,
                        marginBottom: 4,
                      }}
                    >
                      {moment(item.created_at).format(
                        'DD [de] MMMM [às] HH:mm'
                      )}
                    </Typography>
                    {/* TÍTULO */}
                    <Typography
                      variant="h6"
                      style={{
                        fontWeight: 600,
                        marginBottom: 4,
                        color: '#1d1d1d',
                      }}
                    >
                      {item.title}
                    </Typography>

                    {/* IMAGEM */}
                    <Box
                      style={{
                        width: '100%',
                        maxWidth: 800,
                        aspectRatio: '4 / 3', // mantém proporção para vídeos e imagens
                        overflow: 'hidden',
                        borderRadius: 8,
                        cursor: 'pointer',
                        margin: 'auto',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                      onClick={() => {
                        if (item.url) {
                          setCurrentVideo(item);
                          setVideoModal(true);
                        } else {
                          openModal(item);
                        }
                      }}
                    >
                      {item.url ? (
                        <ReactPlayer
                          url={item.url}
                          width="100%"
                          height="100%"
                          style={{ borderRadius: 8 }}
                          controls
                        />
                      ) : (
                        <img
                          src={item.image_url ?? noImage}
                          alt={item.title}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            borderRadius: 8,
                          }}
                        />
                      )}
                    </Box>

                    <span
                      dangerouslySetInnerHTML={{
                        __html: item.description,
                      }}
                    />

                    {/* AÇÕES – CURTIR */}
                    <Box
                      mt={1}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        paddingTop: 8,
                        borderTop: '1px solid #e3e3e3',
                      }}
                    >
                      {/* <Typography
                        style={{ cursor: 'pointer', color: '#6a6a6a' }}
                      >
                        👍 Curtir
                      </Typography> */}
                    </Box>
                  </Box>
                );
              })}
              {hasNextPage && (
                <ButtonLoadMore
                  disabled={!hasNextPage || isFetchingNextPage}
                  loadMore={() => fetchNextPage()}
                  loading={isFetchingNextPage}
                />
              )}
            </React.Fragment>
          ))}
      </PageContainer>
    </>
  );
}
